<template>
  <div class="home">
    <SlideShow />
    <div class="aboutservice">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="heading-it">
              <h1>{{ $t("foundation") }}</h1>
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1587965268/afrikeveil/hero-line.png"
                alt
              />
              <p class="afIntro" v-html="aboutUs"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="latest-news">
      <div class="container">
        <div class="garden-title text-center">
          <h3>our Latest News</h3>
        </div>
        <div class="topBlogs" v-if="topNews">
          <TopBlog topNews v-for="(article, i) in topNews" :key="i" :post="article" />
        </div>
      </div>
    </section>
    <LightBoxVideo />
    <HomeBlogs :blogs="blogs" />
    <Download
      :title="`${this.$i18n.t('brochureText')}`"
      link="https://res.cloudinary.com/yanfomaweb/image/upload/v1577005017/afrikeveil/Trifold-AFRIKEVEIL-2.pdf"
      :buttonTitle="`${this.$i18n.t('brochureButtonTitle')}`"
    />
    <Subscribe />

    <section class="aboutservice">
      <div class="container">
        <div class="garden-title text-center">
          <h3>{{ $t('partners') }}</h3>
        </div>
        <div class="row">
          <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
            <div class="box">
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1579802533/afrikeveil/goethe.png"
                alt
              />
            </div>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
            <div class="box">
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1579802701/afrikeveil/siad.png"
                alt
              />
            </div>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
            <div class="box">
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1579802866/afrikeveil/canid.png"
                alt
              />
            </div>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
            <div class="box">
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1579802941/afrikeveil/seed.png"
                alt
              />
            </div>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
            <div class="box">
              <img
                src="https://res.cloudinary.com/yanfomaweb/image/upload/v1579802941/afrikeveil/yanfoma.png"
                alt
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import Axios from "axios";
import APPURL from "../constant";

export default {
  watch: {
    $route() {
      this.getTopNews();
      this.getInfo();
      this.getBlogs();
    }
  },
  created() {
    document.title = this.$i18n.t("navBar.home");
    //console.log("APPURL.LINK", APPURL.LINK);
  },
  mounted() {
    this.getTopNews();
    this.getInfo();
    this.getBlogs();
    //window.$(this.$refs.owlCarousel).owlCarousel();
  },
  computed: {
    aboutUs() {
      if (this.info[0]) {
        if (this.info[0].aboutFr) {
          return this.info[0].aboutFr;
        } else {
          return this.info[0].aboutUs;
        }
      }
      return "";
    }
  },
  data() {
    return {
      topNews: {},
      info: {},
      blogs: {}
    };
  },
  methods: {
    getNextArticles() {
      this.getArticles(this.posts.next_page_url);
    },
    getTopNews(url = APPURL.LINK + "posts/" + this.$i18n.locale) {
      Axios.get(url).then(response => {
        this.topNews = response.data.data.results.posts;
        //console.log(this.topNews);
      });
    },
    getBlogs(url = APPURL.LINK + "blogs/" + this.$i18n.locale + "/1/3") {
      Axios.get(url).then(response => {
        this.blogs = response.data.data.results.posts;
        // console.log(this.blogs);
      });
    },
    getInfo(url = APPURL.LINK + "settings/" + this.$i18n.locale) {
      Axios.get(url).then(response => {
        this.info = response.data.data.results;
        //console.log(this.info[0]);
      });
    }
  },
  filters: {
    strippedContent: function(string) {
      return string.replace(/<\/?[^>]+>/gi, " ");
    }
  },
  name: "home",
  components: {}
};
</script>

<style>
.aboutservice {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}
.aboutservice .heading-it {
  margin-bottom: 25px;
  text-align: center;
}
.aboutservice .heading-it h1 {
  font-family: "Josefin Sans", sans-serif;
  font-size: 40px;
  color: #000;
  font-weight: 700;
  text-transform: capitalize;
  padding-bottom: 30px;
}
.aboutservice .heading-it img {
  margin-bottom: 15px;
  margin-top: 5px;
}
.aboutservice .heading-it p {
  padding: 0 10px;
  color: #6c6c6c;
}
.afIntro {
  font-family: "Josefin Sans", sans-serif;
  font-size: 18px !important;
  line-height: 1.714em;
}
.garden-title h3 {
  text-transform: capitalize;
  color: #5bbc2e;
}
.latest-news {
  background: #fee7d4;
  padding-top: 80px !important;
  padding-bottom: 80px !important;
}
@media screen and (max-width: 768px) {
}
@media screen and (max-width: 480px) {
  .heading-it h1 {
    font-size: 24px !important;
  }
  .afIntro {
    font-size: 18px !important;
    text-align: justify;
  }
  .latest-news .container {
    margin: -30px !important;
  }
}
@media screen and (max-width: 320px) {
  .heading-it h1 {
    font-size: 20px !important;
  }
  .afIntro {
    font-size: 13px !important;
    text-align: justify;
  }
  .latest-news .container {
    margin: -30px !important;
  }
}
</style>
